<template>
  <v-container class="io-video-main hideScroll" fluid :style="{ 'flex-direction': $vuetify.breakpoint.mobile ? 'column' : 'row'}">
    <div :style="`position: relative; display: flex; flex-grow: ${$vuetify.breakpoint.mobile ? '0':'1'}`" class="io-video-left">
      <!-- Video page app bar - only visible on desktop -->
      <v-sheet v-if="!$vuetify.breakpoint.mobile" style="display: flex; justify-content: space-between; border-bottom: 1px solid lightgrey;">
        <div>
          <v-btn
            v-tooltip="'Back'"
            v-if="!$vuetify.breakpoint.mobile"
            text
            @click="goBack"
            >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="video" class="text-h6 pt-1">
            {{ video.title }}
          </span>
        </div>
        <div style="display: flex; align-items: center;">
          <div
            v-if="isAnalysis && hasSecondVideoUrl"
            class="d-flex align-center mr-2"
          >
            <v-btn
              small
              outlined
              color="primary"
              :disabled="selectedFeed !== 'primary'"
              @click="setPrimarySyncTime"
            >
              Set time
            </v-btn>
            <v-btn
              small
              outlined
              color="success"
              class="ml-1"
              :disabled="selectedFeed !== 'secondary' || primarySyncPoint === null"
              :loading="savingSecondarySync"
              @click="syncSecondaryFeed"
            >
              Sync
            </v-btn>
            <v-chip
              v-if="primarySyncPoint !== null"
              small
              label
              class="ml-2"
            >
              Feed 1: {{ syncPointLabel(primarySyncPoint) }}
            </v-chip>
          </div>
          <v-btn-toggle
            v-if="isGameOrAnalysis && feedOptions.length > 1"
            :value="selectedFeed"
            mandatory
            dense
            class="mr-2"
            @change="handleFeedChange"
          >
            <v-btn
              v-for="feed in feedOptions"
              :key="feed.value"
              small
              :value="feed.value"
            >
              {{ feed.text }}
            </v-btn>
          </v-btn-toggle>
          <v-btn id="video-draw-button" v-if="!this.$vuetify.breakpoint.mobile" :loading="drawLoading" @click="playingClip ? $router.push(`/editor?clip_id=${clip.id}&from=${$route.path}`) : startDrawing()" class="ml-5" small>
            <v-icon>
              mdi-draw
            </v-icon>
            {{ $t('draw') }}
          </v-btn>
          <v-btn
            v-if="!$vuetify.breakpoint.mobile"
            class="ml-2"
            small
            :color="show_measure_tape ? 'primary' : ''"
            @click="toggleMeasureTape"
            v-tooltip="'Mittaa etäisyyksiä kentällä'"
          >
            <v-icon class="mr-2">mdi-ruler</v-icon>
            Mittaa
          </v-btn>
          <!-- <share-btn v-if="!this.isGame" resource_type="video" :resource_id="$route.params.id" class="ml-2" size="small"></share-btn> -->
          <v-btn v-if="!$vuetify.breakpoint.mobile" text @click="toggleSideBar()">
            <v-icon v-if="show_side_bar">
              mdi-arrow-collapse-right
            </v-icon>
            <v-icon v-else>
              mdi-arrow-collapse-left
            </v-icon>
          </v-btn>
        </div>
      </v-sheet>

      <!-- Player container -->
      <v-sheet
        id="video-cont"
        @click="keepVisibleFor(3)"
        @mouseover="keepVisibleFor(3)"
        @mouseleave="resetVisible()"
        :style="`height: min(${ $vuetify.breakpoint.mobile ? 'calc( 100vw / 16 * 9)' : '' }, 100vh)`"
        class="io-video-left-screen"
      >
          <!-- Landscape mobile button -->
          <div id="inline-bar" :style="`position: absolute; bottom: 80px; right: 0px; height: 30px; z-index: 1; opacity: ${ mediacontrol_visible ? '0.7' : '0' };`" v-if="$vuetify.breakpoint.mobile">
            <Bar
              :showMostAnyway="false"
              :hidePlay="true"
            ></Bar>
          </div>
          <!-- Player component -->
          <editor-player
            :isGame="isGame"
            v-if="options"
            :options="options"
            :key="playerKey"
            :measureDistance="true"
          />
      </v-sheet>
      <v-sheet id="bar" style="position: relative;" :class="{ 'mobile-bar': $vuetify.breakpoint.mobile }">
        <!-- <v-btn v-if="!show_timeline && !$vuetify.breakpoint.mobile" x-small @click="showTimeline()" style="position: absolute; top: -30px; right: calc(50% - 50px);">
          <v-icon size="15" class="mr-2">mdi-chart-gantt</v-icon>
          {{ $t('show_timeline') }}
        </v-btn> -->
        <Timeline v-show="show_timeline"></Timeline>
        <Bar v-show="!show_timeline">
        </Bar>
      </v-sheet>
    </div>
    <v-sheet class="io-video-right hideScroll" :style="rightWidth">
      <AnalysisBar ref="analysisBar" v-if="!isAnalysis" :isGame="isGame" :clipsOnly="!!manual_video" :relevantClip="relevantClip" :isAnalysis="isAnalysis"></AnalysisBar>
      <AdminSideBar v-else></AdminSideBar>
    </v-sheet>
    <!-- Mobile back button -->
    <v-btn id="backbutton" small @click="goBack" style="position: fixed; left: 2vh; top: 2vh; z-index: 2; opacity: 0.5" v-if="$vuetify.breakpoint.mobile">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import AnalysisBar from '@/components/video/analysisBar/AnalysisBar.vue'
// import Player from '@/components/video/Player.vue'
import EditorPlayer from '@/components/video/ClipEditor/EditorPlayer.vue'
import Bar from '@/components/video/player/Bar'
// import ShareBtn from '@/components/share/ShareBtn'
import Timeline from '@/components/video/player/Timeline'
// import ClapprMarkersPlugin from 'clappr-markers-plugin'
import AdminSideBar from '@/components/analysis/AdminSideBar.vue'
import { updateTitleFromComponent } from '@/utils/titleHelper'
import time from '@/utils/player/time'
// import { VueScreenSizeMixin } from 'vue-screen-size';
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: ['manual_video'],
  components: {
    AnalysisBar,
    EditorPlayer,
    Bar,
    // ShareBtn,
    Timeline,
    AdminSideBar
  },
  mixins: [
    time,
    // VueScreenSizeMixin
  ],
  created() {
    this.SET_SOURCE_TIME_OFFSET(0)
    let start_at = this.$route.query.t

    if(this.manual_video) {
      this.setVideo(this.manual_video)
      this.$nextTick(() => {
        this.options = {
          source: this.video.mp4_url || this.video.original_url,
          poster: this.video.thumb_url,
          mimeType: 'video/mp4',
          start_at
        }
        this.playerKey++
      })

      return;
    }

    if(!this.isAnalysis && !this.isGame) {
      this.videoById(this.$route.params.id)
        .then(() => {
          this.options = {
            source: this.video.mp4_url || this.video.original_url,
            poster: this.video.thumb_url,
            mimeType: 'video/mp4',
            start_at
          }
          this.playerKey++

          updateTitleFromComponent(this.video.title)

          this.getVideoClips(this.$route.params.id)
        })
        .catch(err => {
          console.log(err)
          this.error(err)
        })
    } else {
      // Liigat
      this.gameById(this.$route.params.id)
        .then((e) => {
          const game = e.data
          this.secondarySyncOffsetInput = game.second_video_sync_offset_seconds
          this.initLeagues(e.data.league_id)
          this.initGamePlayers({ league_game_id: e.data.id, home_club_id: e.data.home_club_id })
          this.getGameEvents(e.data.id)
          if(!this.isAnalysis) {
            this.initGameTimes(e.data.id)
            .then((res) => {
              if(res.length > 0) {
                this.$refs.analysisBar.setShowOwn(false)
              }
            })
          }
          this.getVideoClips(this.$route.params.id)

          const startDate = new Date(game.starttime_unix)
          const formattedDate = `${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')}`

          // Update title with game info and date
          updateTitleFromComponent(`${game.home_club_short_name} - ${game.away_club_short_name} ${formattedDate}`)

          if(!this.canWatchGame(game)) {
            alert('Video ei ole vielä katsottavissa')
            return
          }

          this.setGamePlayerOptions(game, this.selectedFeed, start_at)

          // this.$nextTick(() => {
          //   let points = this.getPointsFromClips(this.video.clips)

          //   if(points[0]) {
          //     let marker1 = new ClapprMarkersPlugin.StandardMarker(points[0], '1st half')
          //     this.player?.core?.plugins[1].addMarker(marker1)
          //   }
          //   if(points[1]) {
          //     let marker2 = new ClapprMarkersPlugin.StandardMarker(points[1], '2nd half')
          //     this.player?.core?.plugins[1].addMarker(marker2)
          //   }
          // })
        })
        .catch(err => {
          this.error(err)
        })
    }

    window.addEventListener('resize', () => {
      this.refresh_player_dimensions++;
    })
  },
  mounted() {
    // Add event listener for 'keydown' events
    window.addEventListener('keydown', this.preventSpacebarScroll);
  },
  data: () => ({
    playerKey: 0,
    options: null,
    selectedFeed: 'primary',
    secondarySyncOffsetInput: null,
    savingSecondarySync: false,
    primarySyncPoint: null,
    relevantClip: null,
    isDarkModeEnabled: window.localStorage.getItem('tiimio-dark') != 'true',
    visibleTimeout: null,
    currentDataOnScreen: [],
    refresh_player_dimensions: 0,
    drawLoading: false
  }),
  computed: {
    ...mapGetters('videos', [
      'video',
      'show_side_bar',
      'show_timeline',
      'loading_video_clips'
    ]),
    ...mapGetters('player', [
      'player',
      'currentTime',
      'markerPlugin',
      'clip',
      'accurateCurrentTime',
      'mediacontrol_visible',
      'playingClip'
    ]),
    ...mapGetters('draw', [
      'canvas_dimensions_key'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('analysis', [
      'show_measure_tape'
    ]),
    playerDimensions() {
      this.refresh_player_dimensions;
      this.show_side_bar;
      this.canvas_dimensions_key;

      const wrap = document.querySelector('#video-cont')
      let he = wrap.offsetHeight
      let wi = wrap.offsetWidth

      const tops_touch = he / 9 < wi / 16

      if(tops_touch) {
        // landscaped
        return {
          width: (he * 16 / 9),
          height: he
        }
      } else {
        // portrait
        return {
          width: wi,
          height: (wi * 9 / 16)
        }
      }
    },
    isAnalysis() {
      return this.$route?.path?.includes('analysis')
    },
    isGame() {
      return this.$route?.path?.includes('games')
    },
    isGameOrAnalysis() {
      return this.isGame || this.isAnalysis
    },
    feedOptions() {
      if(!this.isGameOrAnalysis || !this.video) return []

      const options = [
        { text: 'Feed 1', value: 'primary' }
      ]

      if(this.secondaryFeedSelectable(this.video)) {
        options.push({ text: 'Feed 2', value: 'secondary' })
      }

      return options
    },
    hasSecondVideoUrl() {
      return !!(this.video?.second_video_url || this.video?.second_video_live_url)
    },
    rightWidth() {
      if(this.$vuetify.breakpoint.mobile) return { width: '100%' }
      if(!this.show_side_bar) return "width: 0px; max-width: 0px;"
      return "width: 450px !important; max-width: 450px;"
    }
  },
  methods: {
    ...mapActions('videos', [
      'videoById',
      'getVideoClips',
      'gameById',
      'toggleSideBar',
      'initGameTimes'
    ]),
    ...mapActions('admin', [
      'initLeagues',
      'editGame'
    ]),
    ...mapActions('game', [
      'initGamePlayers',
    ]),
    ...mapActions('noti', [
      'showSnackbar',
      'error',
      'success'
    ]),
    ...mapMutations('draw', [
      'UPDATE_SCALE'
    ]),
    ...mapActions('clip', [
      'addClip'
    ]),
    ...mapMutations('videos', [
      'setShowSideBar',
      'setVideo',
      'setShowTimeline',
      'SET_GAME_TIMES',
      'EMPTY_VIDEO_CLIPS',
      'EMPTY_VIDEO_TIMES'
    ]),
    ...mapActions('analysis', [
      'getGameEvents'
    ]),
    ...mapMutations('analysis', ['SET_SHOW_MEASURE_TAPE']),
    ...mapMutations('player', [
      'SET_SOURCE_TIME_OFFSET'
    ]),
    goBack() {
      if(this.$route.query.from) {
        this.$router.push(this.$route.query.from)
        return
      } else {
        this.$router.replace('/')
      }
    },
    syncOffset(game = this.video) {
      if(!game) return null
      if(game.second_video_sync_offset_seconds === null || game.second_video_sync_offset_seconds === undefined || game.second_video_sync_offset_seconds === '') return null
      return Number(game.second_video_sync_offset_seconds)
    },
    canWatchGame(game) {
      const past_publish = game.publishtime_unix < Date.now()
      const has_live_permission = game.shown_live // ADD TEAM PERMISSION HERE
      return has_live_permission || past_publish
    },
    currentFeedSource(game, feed) {
      const past_publish = game.publishtime_unix < Date.now()

      if(feed === 'secondary') {
        return game.shown_live && !past_publish
          ? game.second_video_live_url || game.second_video_url
          : game.second_video_url || game.second_video_live_url
      }

      const not_live_url = game.video_url || game.original_url
      return game.shown_live && !past_publish ? game.video_live_url || not_live_url : not_live_url
    },
    isLiveFeed(game, feed) {
      if(!game?.shown_live || game.publishtime_unix < Date.now()) return false
      if(feed === 'secondary') return !!game.second_video_live_url
      return !!game.video_live_url
    },
    secondaryFeedAvailable(game = this.video) {
      const offset = this.syncOffset(game)
      return offset !== null && !!this.currentFeedSource(game, 'secondary')
    },
    secondaryFeedSelectable(game = this.video) {
      if(!game) return false
      if(this.isAnalysis) return this.hasSecondVideoUrl
      return this.secondaryFeedAvailable(game)
    },
    setGamePlayerOptions(game, feed = 'primary', start_at) {
      if(feed === 'secondary' && !this.secondaryFeedSelectable(game)) {
        feed = 'primary'
        this.selectedFeed = 'primary'
      }

      const offset = feed === 'secondary' ? this.syncOffset(game) || 0 : 0
      this.SET_SOURCE_TIME_OFFSET(offset)
      const seekTime = Number(start_at || 0)
      this.options = {
        mimeType: game.video_type == 'hls' ? 'application/x-mpegURL' : 'video/mp4',
        source: this.currentFeedSource(game, feed),
        start_at: seekTime
      }
      this.playerKey++

      if(this.isLiveFeed(game, feed) && seekTime > 0) {
        this.seekLiveFeedAfterMount(seekTime)
      }
    },
    seekLiveFeedAfterMount(time) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.player?.seek?.(this.sourceTimeForCurrentFeed(time))
        }, 300)
        setTimeout(() => {
          this.player?.seek?.(this.sourceTimeForCurrentFeed(time))
        }, 900)
      })
    },
    sourceTimeForCurrentFeed(time) {
      const offset = this.selectedFeed === 'secondary' ? this.syncOffset() || 0 : 0
      return Math.max(0, time + offset)
    },
    currentPlaybackTime() {
      return Number(this.accurateCurrentTime || this.currentTime || 0)
    },
    rawPlaybackTime() {
      const playerTime = this.player?.getCurrentTime?.()
      if(playerTime !== null && playerTime !== undefined && !Number.isNaN(Number(playerTime))) return Number(playerTime)
      return Number(this.accurateCurrentTime || this.currentTime || 0)
    },
    startTimeForFeed(feed, previousFeed, previousTime) {
      feed
      previousFeed
      return previousTime
    },
    setPrimarySyncTime() {
      const time = this.currentPlaybackTime()
      this.primarySyncPoint = time
      this.selectedFeed = 'secondary'
      this.setGamePlayerOptions(this.video, 'secondary', time)
    },
    syncPointLabel(time) {
      if(time === null || time === undefined || time === '') return 'Not set'
      return `${Number(time).toFixed(3)}s`
    },
    handleFeedChange(feed) {
      if(!this.video || !this.options) return

      const previousFeed = this.selectedFeed
      const previousTime = this.currentPlaybackTime()
      this.selectedFeed = feed
      const start_at = this.startTimeForFeed(feed, previousFeed, previousTime)

      this.setGamePlayerOptions(this.video, feed, start_at)
    },
    syncSecondaryFeed() {
      if(this.primarySyncPoint === null) return
      this.secondarySyncOffsetInput = Number((this.rawPlaybackTime() - this.primarySyncPoint).toFixed(3))
      this.saveSecondarySync()
    },
    saveSecondarySync() {
      if(!this.video) return

      const offset = this.secondarySyncOffsetInput === '' || this.secondarySyncOffsetInput === null || this.secondarySyncOffsetInput === undefined
        ? null
        : Number(this.secondarySyncOffsetInput)

      this.savingSecondarySync = true
      this.editGame({
        ...this.video,
        second_video_sync_offset_seconds: offset
      })
        .then(res => {
          const updatedGame = res.data || {
            ...this.video,
            second_video_sync_offset_seconds: offset
          }
          this.setVideo(updatedGame)
          this.secondarySyncOffsetInput = updatedGame.second_video_sync_offset_seconds
          if(this.selectedFeed === 'secondary' && !this.secondaryFeedAvailable(updatedGame)) {
            this.selectedFeed = 'primary'
            this.setGamePlayerOptions(updatedGame, 'primary', this.accurateCurrentTime || this.currentTime || 0)
          } else if(this.selectedFeed === 'secondary') {
            this.SET_SOURCE_TIME_OFFSET(this.syncOffset(updatedGame) || 0)
          }
          this.success('Sync saved')
        })
        .catch(e => {
          this.error(e)
        })
        .finally(() => {
          this.savingSecondarySync = false
        })
    },
    showTimeline() {
      this.setShowTimeline('true')

      this.$nextTick(() => {
        this.UPDATE_SCALE()
      })
    },
    preventSpacebarScroll(event) {
      // Check if the pressed key is spacebar (key code 32)
      if (event.keyCode === 32 && (event.target === document.body || event.target.id == 'tag-adder')) {
        // Prevent the default action to stop scrolling
        event.preventDefault();
        // Your code to play/pause the video goes here
      }
    },
    startDrawing() {
      this.drawLoading = true;

      this.addClip({
        leaguewide: false,
        title: "New clip",
        starttime: Math.max(this.currentTime - 3),
        endtime: this.currentTime + 3,
        tags: [],
        video_id: this.isGame ? undefined : this.$route.params.id,
        game_id: !this.isGame ? undefined : this.$route.params.id,
      })
      .then(e => {
        this.$router.push(`/editor?clip_id=${e.data?.id}&from=${this.$route.path}&seek=${this.accurateCurrentTime}&delete_if_no_graphics=true`)
      })
      .catch((e) => {
        this.error(e)
      })
      .finally(() => {
        this.drawLoading = false;
      })
    },
    keepVisibleFor(time) {
      clearTimeout(this.visibleTimeout)

      this.player?.core.mediaControl.setKeepVisible()
      this.visibleTimeout = setTimeout(() => {
        this.player?.core.mediaControl.resetKeepVisible()
      }, time * 1000)
    },
    resetVisible() {
      this.player?.core.mediaControl.resetKeepVisible()
    },
    toggleMeasureTape() {
      this.SET_SHOW_MEASURE_TAPE(!this.show_measure_tape);
    }
  },
  watch: {
    currentTime: {
      handler(newVal) {
        this.relevantClip = this.findRelevantClip(newVal, this.video.clips)
      }
    }
  },
  beforeDestroy() {
    this.SET_SOURCE_TIME_OFFSET(0)
    this.SET_GAME_TIMES([])
    this.EMPTY_VIDEO_CLIPS()
    this.EMPTY_VIDEO_TIMES()
  }
}
</script>

<style lang="scss" scoped>
.io-video {
  overflow-x: hidden;

  &-main {
    overflow-x: hidden;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 0;
  }

  &-left {
    display: flex;
    flex-direction: column;

    &-screen {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
    }

    &-bar {
      height: 10vh;
    }
  }

  &-right {
    max-height: 100vh;
    overflow-y: scroll;
    border-left: 2px solid rgb(208, 208, 208);
  }
}

#inline-bar {
  transition-duration: 0.3s;
  width: 100vw;
  display: flex;
  justify-content: center;
}

@media (orientation: landscape) {
  .mobile-bar {
    display: none;
  }

  #inline-bar {
    display: block;
  }

  #backbutton {
    top: 10px !important;
  }
}

@media (orientation: landscape) and (max-width: 960px) {
  #video-cont {
    height: 100vh !important;
  }
}

@media (orientation: portrait) {
  #inline-bar {
    display: none;
  }
}

</style>